export default "__VITE_PUBLIC_ASSET__a1a5c4bc__"